const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const IpWhiteListCommand: any = {
    AddIpWhiteList: `${Backofficebff}/v1/studioipwhitelist/add`,
    UpdateIpWhiteList: `${Backofficebff}/v1/studioipwhitelist/update`,
    DeleteIpWhiteList: `${Backofficebff}/v1/studioipwhitelist/delete`,
};

